import { render, staticRenderFns } from "./TermsOfUseDefault.vue?vue&type=template&id=3b5f85aa&scoped=true"
import script from "./TermsOfUseDefault.vue?vue&type=script&lang=js"
export * from "./TermsOfUseDefault.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseDefault.vue?vue&type=style&index=0&id=3b5f85aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f85aa",
  null
  
)

export default component.exports